import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductServices', request)
}

async function post(request) {
    return await postMethod('/api/ownProductServices', request)
}

async function put(request) {
    return await putMethod('/api/ownProductServices', request)
}

export {get, post, put}
